export default "__VITE_ASSET__yvB$7HDt$fxaXJ7DG0VO2g__"